<template>
  <div v-if="store.form.currentStep === 'stepFour'">
    <!--    <Steps class="mt-4 mt-md-0"/>-->
    {{ this.store.vueClarityEvent('thank-you') }}
    {{ this.store.tradeClarityEvent('thank-you') }}

    <div id="thankYou" class="p-5 text-center">

      <div class="circle border-secondary ml-auto mr-auto d-flex justify-content-center align-items-center mb-4">
        <svg width="21" height="16" viewBox="0 0 21 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M2.9502 7.90015L8.2002 13.1501L18.7002 2.65015" stroke="#EF4956" stroke-width="3"
                stroke-linecap="square"/>
        </svg>
      </div>

      <!--      NADPIS-->
      <p class="header text-center">{{ t('thankYou.dekujeme') }}
        <span v-if="store.order.type === 'order'">{{ t('thankYou.objednavku') }}</span>
        <span v-else>{{ t('thankYou.poptavnku') }}</span>
        <span v-if="profile.czTypography">&nbsp;{{ t('thankYou.zivnostiNadpis') }}</span>!</p>

      <!--      PRVNÍ ODSTAVEC-->
      <p v-if="store.order.type === 'order'">
        <span v-html="t('thankYou.order.beforeEmail')"></span>
        <b>{{ store.order.contactInfo.email }}</b>
        <span v-html="t('thankYou.order.afterEmail')"></span>
      </p>
      <p v-else-if="store.order.type === 'demand'">
        <span>{{t('thankYou.demand.beforeEmail')}}</span>
        <strong>
          {{t('thankYou.demand.beforeEmailStrong')}}
          {{ store.order.contactInfo.email }}{{t('thankYou.demand.afterEmailStrong')}}
        </strong>
        <span>{{t('thankYou.demand.afterEmail')}}</span>
      </p>
<!--      <p v-else>-->

<!--        {{ t('thankYou.zivnosti') }}-->

<!--        &lt;!&ndash;        en&ndash;&gt;-->
<!--        <span v-if="store.order.type === 'order'">&nbsp;{{ t('thankYou.objednavku') }}&nbsp;</span>-->
<!--        <span v-else>&nbsp;{{ t('thankYou.poptavnku') }}&nbsp;</span>-->
<!--        &lt;!&ndash;        /en&ndash;&gt;-->

<!--        <b> {{ t('thankYou.prijali') }}</b>.-->
<!--        {{ t('thankYou.ozveme') }}-->
<!--        <b>{{ store.order.contactInfo.email }}</b>,-->
<!--        {{ t('thankYou.abychom') }}-->
<!--      </p>-->

      <!--      DRUHÝ ODSTAVEC-->
      <p>
        {{ t('thankYou.dotaz') }} <b> {{ t('thankYou.nevahejte') }}
        <a :href="t('thankYou.url')">{{ t('thankYou.kontaktovat') }}</a></b>.
      </p>
      <!--      TŘETÍ ODSTAVEC-->
      <p>{{ t('thankYou.coTed') }}</p>
      <div class="text-center">
        <a class="btn btn-secondary" href="/blog">{{ t('thankYou.blog') }}</a>
      </div>
    </div>

  </div>

</template>

<script>
import {useI18n} from "vue-i18n";
import {useLocaleProfile} from "@/composables/useLocaleProfile";
import {ref} from 'vue'
import {store} from "../store.js";
import Steps from "../others/StepsComponent/Steps.vue";

export default {
  name: "ThankYou",
  components: {Steps},
  props: ['currentStep'],

  setup() {
    const {t, locale} = useI18n({useScope: 'global'})
    const {profile} = useLocaleProfile()
    const select = ref(0)
    const lang = locale;
    return {t, select, lang, profile}
  },
  data() {
    return {
      errors: [],
      store,

    }
  },
  methods: {},
  created() {


  },

}
</script>

<style lang="scss" scoped>
#thankYou {
  p {
    font-size: 14px;
    font-weight: 600
  }

  .header {
    font-size: 1.4rem;
    color: #ef4956;
    font-weight: bold;
  }

  .circle {
    width: 43px;
    height: 43px;
    border-radius: 50%;
    border-width: 3px;
    border-style: solid;
  }
}

</style>